import React from "react";
import { View } from "react-native";
import Svg, { Line } from "react-native-svg";

export type LevelIndicatorLevel = 1 | 2 | 3;

const VIEWBOX = 18;

const SVG_BARS = [
  { x: 1.75, y1: 16.1875, y2: 11.7452 },
  { x: 8.75, y1: 16.1875, y2: 6.74756 },
  { x: 15.75, y1: 16.1875, y2: 1.75 },
] as const;

const STROKE_WIDTH = 3.5;

type LevelIndicatorBarsProps = {
  level: LevelIndicatorLevel;
  activeColor: string;
  inactiveColor: string;
  /** Legacy; fixed SVG geometry — unused. */
  gap?: number;
  /** Pixel box for the icon; viewBox stays 18×18 so strokes scale. Default 18. */
  size?: number;
};

export function LevelIndicatorBars({
  level,
  activeColor,
  inactiveColor,
  gap: _gap = 2,
  size = VIEWBOX,
}: LevelIndicatorBarsProps) {
  const activeBars = Math.min(Math.max(level, 1), 3);
  const box = Math.max(1, size);

  return (
    <View
      style={{
        width: box,
        height: box,
        flexShrink: 0,
      }}
    >
      <Svg width={box} height={box} viewBox={`0 0 ${VIEWBOX} ${VIEWBOX}`}>
        {SVG_BARS.map((b, idx) => (
          <Line
            key={`bar-${idx}`}
            x1={b.x}
            y1={b.y1}
            x2={b.x}
            y2={b.y2}
            stroke={idx < activeBars ? activeColor : inactiveColor}
            strokeWidth={STROKE_WIDTH}
            strokeLinecap="round"
          />
        ))}
      </Svg>
    </View>
  );
}
